export const validateInputFields = (_, value) => {
  console.log("input validation - ", value);
  if (!value) {
    return Promise.reject(new Error("Missing mandatory field"));
  }
  if (/^\s/.test(value)) {
    return Promise.reject(new Error("Input cannot start with a space"));
  }
  if (value.length < 3 || value.length > 255) {
    return Promise.reject(new Error("Input must be between 3-255 characters"));
  }
  return Promise.resolve();
};

export const validateOptionalInputFields = (_, value) => {
  console.log("input validation - ", value);
  if (!value) {
    return Promise.resolve();
  }
  if (/^\s/.test(value)) {
    return Promise.reject(new Error("Input cannot start with a space"));
  }
  if (value.length < 3 || value.length > 255) {
    return Promise.reject(new Error("Input must be between 3-255 characters"));
  }
  return Promise.resolve();
};

export const validateDescriptionFields = (_, value) => {
  console.log("input validation - ", value);
  if (!value) {
    return Promise.reject(new Error("Missing mandatory field"));
  }
  if (/^\s/.test(value)) {
    return Promise.reject(new Error("Input cannot start with a space"));
  }
  if (value && value.length < 2) {
    return Promise.reject(new Error("Input must contain atleast 2 characters"));
  }
  return Promise.resolve();
};

export const validateOptionalDescriptionFields = (_, value) => {
  console.log("input validation - ", value);
  if (/^\s/.test(value)) {
    return Promise.reject(new Error("Input cannot start with a space"));
  }
  if (value && value.length < 2) {
    return Promise.reject(new Error("Input must contain atleast 2 characters"));
  }
  return Promise.resolve();
};

export const validateInputSlug = (_, value) => {
  if (!value) {
    return Promise.reject(new Error("Missing mandatory field"));
  }
  if (!/^[a-zA-Z0-9-]*$/.test(value)) {
    return Promise.reject(
      new Error("Slug must be alphanumeric value separated with '-'")
    );
  }
  return Promise.resolve();
};

export const validateNumberField = (_, value) => {
  console.log(value);
  if (!value) {
    return Promise.reject(new Error("Missing mandatory field"));
  }
  if (!/^\d+$/.test(value)) {
    return Promise.reject(new Error("Enter only numbers"));
  }
  return Promise.resolve();
};

export const validateOptionalNumberField = (_, value) => {
  console.log(value);
  if (!value) {
    return Promise.resolve();
  }
  if (!/^\d+$/.test(value)) {
    return Promise.reject(new Error("Enter only numbers"));
  }
  return Promise.resolve();
};

export const validateWebsiteInput = (_, value) => {
  if (!value) {
    return Promise.resolve();
  }
  if (/^\s/.test(value)) {
    return Promise.reject(new Error("URL cannot start with a space"));
  }
  if (!value.startsWith("https://")) {
    return Promise.reject(new Error("Enter valid url"));
  }
  if (value.includes(" ")) {
    return Promise.reject(new Error("URL cannot contain spaces"));
  }
  return Promise.resolve();
};

export const validateYoutubeInput = (_, value) => {
  if (!value) {
    return Promise.resolve();
  }
  if (/^\s/.test(value)) {
    return Promise.reject(new Error("URL cannot start with a space"));
  }
  if (
    !value.startsWith("https://www.youtube.com/") &&
    !value.startsWith("https://youtu.be/") &&
    !value.startsWith("https://www.youtube.com/watch")
  ) {
    return Promise.reject(new Error("Enter valid url"));
  }
  if (value.includes(" ")) {
    return Promise.reject(new Error("URL cannot contain spaces"));
  }
  return Promise.resolve();
};

export const validateLinkedinInput = (_, value) => {
  if (!value) {
    return Promise.resolve();
  }
  if (/^\s/.test(value)) {
    return Promise.reject(new Error("URL cannot start with a space"));
  }
  if (!value.startsWith("https://www.linkedin.com/")) {
    return Promise.reject(new Error("Enter valid url"));
  }
  if (value.includes(" ")) {
    return Promise.reject(new Error("URL cannot contain spaces"));
  }
  return Promise.resolve();
};

export const validateTwitterInput = (_, value) => {
  if (!value) {
    return Promise.resolve();
  }
  if (/^\s/.test(value)) {
    return Promise.reject(new Error("URL cannot start with a space"));
  }
  if (!value.startsWith("https://x.com/")) {
    return Promise.reject(new Error("Enter valid url"));
  }
  if (value.includes(" ")) {
    return Promise.reject(new Error("URL cannot contain spaces"));
  }
  return Promise.resolve();
};

export const validateApplePodcastInput = (_, value) => {
  if (!value) {
    return Promise.resolve();
  }
  if (/^\s/.test(value)) {
    return Promise.reject(new Error("URL cannot start with a space"));
  }
  if (value.includes(" ")) {
    return Promise.reject(new Error("URL cannot contain spaces"));
  }
  return Promise.resolve();
};

export const validateSpotifyInput = (_, value) => {
  if (!value) {
    return Promise.resolve();
  }
  if (/^\s/.test(value)) {
    return Promise.reject(new Error("URL cannot start with a space"));
  }
  if (!value.startsWith("https://open.spotify.com/")) {
    return Promise.reject(new Error("Enter valid url"));
  }
  if (value.includes(" ")) {
    return Promise.reject(new Error("URL cannot contain spaces"));
  }
  return Promise.resolve();
};
